import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { ArrowRightIcon } from 'lucide-react';
export function UseCases() {
  const {
    t
  } = useLanguage();
  const cases = [{
    image: 'https://cdn.magicpatterns.com/uploads/p232H65XodwghzXQZJVxjf/Gemini_Generated_Image_vnjcssvnjcssvnjc.png',
    tag: t('useCases.case1.tag'),
    title: t('useCases.case1.title'),
    description: t('useCases.case1.description'),
    product: t('useCases.case1.product'),
    alt: 'NeuroSpice Focus paprika & chilli blend sprinkled over avocado toast in a modern kitchen'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/gaB8M2xBUhMqTjVWrHJMSb/Gemini_Generated_Image_ough4gough4gough.png',
    tag: t('useCases.case2.tag'),
    title: t('useCases.case2.title'),
    description: t('useCases.case2.description'),
    product: t('useCases.case2.product'),
    alt: 'Bartender rimming a cocktail glass with NeuroSpice Calm salt at a modern bar'
  }];
  return <section className="w-full py-24 px-6 bg-white border-t-2 border-black" data-id="element-432">
      <div className="max-w-6xl mx-auto" data-id="element-433">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-434">
          <div className="inline-block px-4 py-1 border border-black text-xs font-mono tracking-wider uppercase mb-6" data-id="element-435">
            {t('useCases.badge')}
          </div>
          <h2 className="text-5xl md:text-7xl font-black text-black mb-6 uppercase tracking-tighter leading-none" style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          fontStretch: 'condensed'
        }} data-id="element-436">
            {t('useCases.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-437">
            {t('useCases.subtitle')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-438">
          {cases.map((c, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="group relative border-2 border-black overflow-hidden bg-white" data-id="element-439">
              {/* Image */}
              <div className="relative aspect-[4/3] overflow-hidden bg-gray-100" data-id="element-440">
                <img src={c.image} alt={c.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-441" />
                <div className="absolute top-4 left-4 px-3 py-1 bg-black text-white text-xs font-black uppercase tracking-wider" data-id="element-442">
                  {c.tag}
                </div>
              </div>

              {/* Content */}
              <div className="p-6 border-t-2 border-black" data-id="element-443">
                <div className="text-xs font-mono uppercase tracking-widest text-gray-500 mb-2" data-id="element-444">
                  {c.product}
                </div>
                <h3 className="text-2xl md:text-3xl font-black uppercase tracking-tight mb-3" style={{
              fontFamily: 'system-ui, -apple-system, sans-serif',
              fontStretch: 'condensed'
            }} data-id="element-445">
                  {c.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-446">
                  {c.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* B2B Teaser */}
        <motion.a href="mailto:hello@thisisneurospice.com?subject=Bulk%20%2F%20B2B%20Enquiry" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="block group border-2 border-black p-6 md:p-8 bg-black text-white hover:bg-white hover:text-black transition-colors duration-300" data-id="element-447">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4" data-id="element-448">
            <div className="flex-1" data-id="element-449">
              <div className="text-xs font-mono uppercase tracking-widest opacity-70 mb-2" data-id="element-450">
                {t('useCases.b2b.tag')}
              </div>
              <h3 className="text-2xl md:text-3xl font-black uppercase tracking-tight mb-1" style={{
              fontFamily: 'system-ui, -apple-system, sans-serif',
              fontStretch: 'condensed'
            }} data-id="element-451">
                {t('useCases.b2b.title')}
              </h3>
              <p className="text-sm opacity-80" data-id="element-452">
                {t('useCases.b2b.description')}
              </p>
            </div>
            <div className="flex items-center gap-2 text-sm font-black uppercase tracking-widest whitespace-nowrap" data-id="element-453">
              {t('useCases.b2b.cta')}
              <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-454" />
            </div>
          </div>
        </motion.a>
      </div>
    </section>;
}